import { render, staticRenderFns } from "./unable-item.vue?vue&type=template&id=1215e635&scoped=true&"
import script from "./unable-item.vue?vue&type=script&lang=js&"
export * from "./unable-item.vue?vue&type=script&lang=js&"
import style0 from "./unable-item.vue?vue&type=style&index=0&id=1215e635&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1215e635",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrawerHeader: require('/app/components/drawer/components/drawerHeader.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
